export default function errorHandler(error, setAlertModal) {
  if (error.message === "Failed to fetch") {
    setAlertModal(
      "ERR_CONNECTION_REFUSED Unable to connect to Terralanes' servers."
    );
  }
  console.error(error);
}
